@if (hasSearched()) {
    <div class="results_info">
        <div>{{ resultsSum() }} results</div>
        <div>
            @if (hasLocations()) {
                <button
                    class="btn btn-primary mr-2"
                    type="button"
                    [attr.aria-label]="'accessibility.download-search-results' | translate"
                    (click)="download()"
                >
                    <si-icon icon="element-download" />
                    {{ 'download' | translate }}
                </button>
            }
        </div>
    </div>
}
@if (isLoading()) {
    <div class="loading-state" aria-live="polite">
        <si-loading-spinner />
    </div>
} @else {
    @if (countries().length > 0) {
        <div>
            @for (country of countries(); track country) {
                <div>
                    <app-result-item [type]="ResultItemType.COUNTRY" [itemCountry]="country"></app-result-item>
                </div>
            }
        </div>
    }
    @if (locations().length > 0) {
        <div>
            @for (location of locations(); track location) {
                <div>
                    <app-result-item [type]="ResultItemType.LOCATION" [itemLocation]="location"></app-result-item>
                </div>
            }
        </div>
    }
}
